import { darkenColor } from "../utilities/extensions"

export default class AffiliateData {
  account
  affiliateDashboardLeadStages
  subAffiliatesDashboardLeadStages
  subAffiliates
  resources
  accessToken

  constructor() {
    this.account = new Account()
    this.affiliateDashboardLeadStages = new DashboardLeadStages()
    this.subAffiliatesDashboardLeadStages = new DashboardLeadStages()
    this.subAffiliates = []
    this.resources = new Resources()
    this.accessToken = String('')
  }

  setAffiliateData(affiliateData = {}) {
    this.account = affiliateData.account ? new Account(affiliateData.account) : new Account()
    this.affiliateDashboardLeadStages = affiliateData.affiliateDashboardLeadStages ? new DashboardLeadStages(affiliateData.affiliateDashboardLeadStages) : new DashboardLeadStages()
    this.subAffiliatesDashboardLeadStages = affiliateData.subAffiliatesDashboardLeadStages ? new DashboardLeadStages(affiliateData.subAffiliatesDashboardLeadStages) : new DashboardLeadStages()
    this.subAffiliates = affiliateData.subAffiliates ? [...affiliateData.subAffiliates] : []
    this.accessToken = affiliateData.accessToken ? String(affiliateData.accessToken) : ''
  }
}

class DashboardLeadStages {
  estimatedTotalStage
  intakeLeadsStage
  advanceFundingStage
  issueLeadsStage
  notQualifiedLeadsStage
  postPaidLeadsStage
  prePaidLeadsStage
  completedLeadsStage

  constructor(dashboardLeadStages = {}) {
    this.estimatedTotalStage = dashboardLeadStages.estimatedTotalStage ? new DashboardStage(dashboardLeadStages.estimatedTotalStage) : new DashboardStage()
    this.intakeLeadsStage = dashboardLeadStages.dashboardLeadStages ? [...dashboardLeadStages.dashboardLeadStages.intakeLeadsStage] : []
    this.advanceFundingStage = dashboardLeadStages.dashboardLeadStages ? [...dashboardLeadStages.dashboardLeadStages.advanceFundingStage] : []
    this.issueLeadsStage = dashboardLeadStages.dashboardLeadStages ? [...dashboardLeadStages.dashboardLeadStages.issueLeadsStage] : []
    this.notQualifiedLeadsStage = dashboardLeadStages.dashboardLeadStages ? [...dashboardLeadStages.dashboardLeadStages.notQualifiedLeadsStage] : []
    this.postPaidLeadsStage = dashboardLeadStages.dashboardLeadStages ? [...dashboardLeadStages.dashboardLeadStages.postPaidLeadsStage] : []
    this.prePaidLeadsStage = dashboardLeadStages.dashboardLeadStages ? [...dashboardLeadStages.dashboardLeadStages.prePaidLeadsStage] : []
    this.completedLeadsStage = dashboardLeadStages.dashboardLeadStages ? [...dashboardLeadStages.dashboardLeadStages.completedLeadsStage] : []
  }

  getTotalIntakeLeadsData() {
    return this.intakeLeadsStage.reduce((totals, stage) => {
      totals.totalLeads += stage.totalLeads
      totals.totalAmount += stage.totalAmount
      return totals
    }, { totalLeads: 0, totalAmount: 0 })
  }
  getTotalAdvanceFundingData() {
    return this.advanceFundingStage.reduce((totals, stage) => {
      totals.totalLeads += stage.totalLeads
      totals.totalAmount += stage.totalAmount
      return totals
    }, { totalLeads: 0, totalAmount: 0 })
  }
  getTotalIssueLeadsData() {
    return this.issueLeadsStage.reduce((totals, stage) => {
      totals.totalLeads += stage.totalLeads
      totals.totalAmount += stage.totalAmount
      return totals
    }, { totalLeads: 0, totalAmount: 0 })
  }
  getTotalNotQualifiedLeadsData() {
    return this.notQualifiedLeadsStage.reduce((totals, stage) => {
      totals.totalLeads += stage.totalLeads
      totals.totalAmount += stage.totalAmount
      return totals
    }, { totalLeads: 0, totalAmount: 0 })
  }
  getTotalPostPaidLeadsData() {
    return this.postPaidLeadsStage.reduce((totals, stage) => {
      totals.totalLeads += stage.totalLeads
      totals.totalAmount += stage.totalAmount
      return totals
    }, { totalLeads: 0, totalAmount: 0 })
  }
  getTotalPrePaidLeadsData() {
    return this.issueLeadsStage.reduce((totals, stage) => {
      totals.totalLeads += stage.totalLeads
      totals.totalAmount += stage.totalAmount
      return totals
    }, { totalLeads: 0, totalAmount: 0 })
  }
  getTotalCompletedLeadsData() {
    return this.completedLeadsStage.reduce((totals, stage) => {
      totals.totalLeads += stage.totalLeads
      totals.totalAmount += stage.totalAmount
      return totals
    }, { totalLeads: 0, totalAmount: 0 })
  }
}

class DashboardStage {
  leadStageId
  leadStageName
  totalLeads
  totalAmount

  constructor(dashboardStageData = {}) {
    this.leadStageId = dashboardStageData.leadStageId ? String(dashboardStageData.leadStageId) : ''
    this.leadStageName = dashboardStageData.leadStageName ? String(dashboardStageData.leadStageName) : ''
    this.totalLeads = dashboardStageData.totalLeads ? Number(dashboardStageData.totalLeads) : 0
    this.totalAmount = dashboardStageData.totalAmount ? Number(dashboardStageData.totalAmount) : 0
  }
}

class Account {
  accountId
  accountType
  accountName
  accountEmail
  accountPhone
  accountLinks

  constructor(account = {}) {
    if (account.affiliateId) {
      this.accountId = account.affiliateId ? String(account.affiliateId) : ''
      this.accountType = 'affiliate'
      this.accountName = account.affiliateName ? String(account.affiliateName) : ''
      this.accountEmail = account.affiliateEmail ? String(account.affiliateEmail) : ''
      this.accountPhone = account.affiliatePhone ? String(account.affiliatePhone) : ''
      this.accountLinks = account.affiliateLinks ? [...account.affiliateLinks] : ''
    } else {
      this.accountId = account.userId ? String(account.userId) : ''
      this.accountType = 'user'
      this.accountName = account.userName ? String(account.userName) : ''
      this.accountEmail = account.userEmail ? String(account.userEmail) : ''
      this.accountPhone = account.userPhone ? String(account.userPhone) : ''
      this.accountLinks = account.affiliateLinks ? [...account.affiliateLinks] : []
    }
  }
}

export class AffiliateLink {
  linkId
  affiliateId
  linkURL

  constructor(affiliateLink = {}) {
    this.linkId = affiliateLink.linkId ? String(affiliateLink.linkId) : ''
    this.affiliateId = affiliateLink.affiliateId ? String(affiliateLink.affiliateId) : ''
    this.linkURL = affiliateLink.linkURL ? String(affiliateLink.linkURL) : ''
  }
}

class AffiliateLeads {
  leadsData
  subAffiliateLeadsData

  constructor(affiliateLeads = {}) {
    this.leadsData = affiliateLeads.leadsData ? new LeadsData(affiliateLeads.leadsData) : new LeadsData()
    this.subAffiliateLeadsData = affiliateLeads.subAffiliateLeadsData ? new LeadsData(affiliateLeads.subAffiliateLeadsData) : new LeadsData()
  }
}

class LeadsData {
  totalLeadsData
  dashboardLeadStages
  leads

  constructor(leadsData = {}) {
    this.totalLeadsData = leadsData.totalLeadsData ? new TotalLeadsData(leadsData.totalLeadsData) : new TotalLeadsData()
    this.dashboardLeadStages = leadsData.dashboardLeadStages ? [...leadsData.dashboardLeadStages] : []
    this.leads = leadsData.leads ? [...leadsData.leads] : []
  }

  getLeads(filterLeadStages) {
    if (filterLeadStages.length > 0)
      return this.leads.filter(lead => lead.leadStage.leadStageName === filterLeadStages)
    else
      return this.leads
  }
}

class TotalLeadsData {
  totalLeads
  totalAmount
  subAffiliates
  totalSubAffiliates
  totalSubAffiliateLeads

  constructor(totalLeadsData = {}) {
    this.totalLeads = totalLeadsData.totalLeads ? Number(totalLeadsData.totalLeads) : 0
    this.totalAmount = totalLeadsData.totalAmount ? Number(totalLeadsData.totalAmount) : 0
    this.subAffiliates = totalLeadsData.subAffiliates ? [...totalLeadsData.subAffiliates] : []
    this.totalSubAffiliates = totalLeadsData.totalSubAffiliates ? Number(totalLeadsData.totalSubAffiliates) : 0
    this.totalSubAffiliateLeads = totalLeadsData.totalSubAffiliateLeads ? Number(totalLeadsData.totalSubAffiliateLeads) : 0
  }
}

class Resources {
  videos
  links

  constructor(resourcesData = {}) {
    this.videos = resourcesData.videos ? [...resourcesData.videos] : []
    this.links = resourcesData.links ? [...resourcesData.links] : []
  }

  setResources(resourcesData) {
    this.videos = resourcesData.videos ? [...resourcesData.videos] : []
    this.links = resourcesData.links ? [...resourcesData.links] : []
  }
}

export class StatsData {
  taxStatusCompletePercentage
  customerPortalPercentage
  bankingInfoAddedPercentage
  calculatorData
  avgRefundAmount

  constructor(statsData = {}) {
    this.taxStatusCompletePercentage = statsData.taxStatusCompletePercentage ? new PercentageData(statsData.taxStatusCompletePercentage) : new PercentageData()
    this.customerPortalPercentage = statsData.customerPortalPercentage ? new PercentageData(statsData.customerPortalPercentage) : new PercentageData
    this.bankingInfoAddedPercentage = statsData.bankingInfoAddedPercentage ? new PercentageData(statsData.bankingInfoAddedPercentage) : new PercentageData()
    this.calculatorData = statsData.calculatorData ? new CalculatorData(statsData.calculatorData) : new CalculatorData()
    this.avgRefundAmount = statsData.avgRefundAmount ? Number(statsData.avgRefundAmount) : 0
  }
}

class CalculatorData {
  dnqData
  refundData
  calculatorData

  constructor(calculatorData = {}) {
    this.dnqData = calculatorData.dnqData ? new PercentageData(calculatorData.dnqData) : new PercentageData()
    this.refundData = calculatorData.refundData ? new PercentageData(calculatorData.refundData) : new PercentageData()
    this.calculatorData = calculatorData.calculatorData ? new PercentageData(calculatorData.calculatorData) : new PercentageData()
  }
}

class PercentageData {
  percentage
  totalLeads

  constructor(percentageData = {}) {
    this.percentage = percentageData.percentage ? Number(percentageData.percentage) : 0
    this.totalLeads = percentageData.totalLeads ? Number(percentageData.totalLeads) : 0
  }
}

export class Company {
  companyId
  companyName
  companyLogoURL
  companyFavIconURL
  companyEmail
  companyPhone
  companyURL
  companyPrimaryColor
  companyPrimaryDarkColor
  companySecondaryColor
  companySecondaryDarkColor
  companyCreatedAt

  constructor(company = {}) {
    this.companyId = company.companyId ? String(company.companyId) : ''
    this.companyName = company.companyName ? String(company.companyName) : ''
    this.companyLogoURL = company.companyLogoURL ? String(company.companyLogoURL) : ''
    this.companyFavIconURL = company.companyFavIconURL ? String(company.companyFavIconURL) : ''
    this.companyEmail = company.companyEmail ? String(company.companyEmail) : ''
    this.companyPhone = company.companyPhone ? String(company.companyPhone) : ''
    this.companyURL = company.companyURL ? String(company.companyURL) : ''
    this.companyPrimaryColor = company.companyPrimaryColor ? String(company.companyPrimaryColor) : ''
    this.companyPrimaryDarkColor = company.companyPrimaryDarkColor ? String(company.companyPrimaryDarkColor) : ''
    this.companySecondaryColor = company.companySecondaryColor ? String(company.companySecondaryColor) : ''
    this.companyCreatedAt = company.companyCreatedAt ? new Date(company.companyCreatedAt) : new Date()
  }

  setCompany(company = {}) {
    this.companyId = company.companyId ? String(company.companyId) : ''
    this.companyName = company.companyName ? String(company.companyName) : ''
    this.companyLogoURL = company.companyLogoURL ? String(company.companyLogoURL) : ''
    this.companyFavIconURL = company.companyFavIconURL ? String(company.companyFavIconURL) : ''
    this.companyEmail = company.companyEmail ? String(company.companyEmail) : ''
    this.companyPhone = company.companyPhone ? String(company.companyPhone) : ''
    this.companyURL = company.companyURL ? String(company.companyURL) : ''
    this.companyPrimaryColor = company.companyPrimaryColor ? String(company.companyPrimaryColor) : ''
    this.companyPrimaryDarkColor = company.companyPrimaryColor ? String(darkenColor(company.companyPrimaryColor, 20)) : ''
    this.companySecondaryColor = company.companySecondaryColor ? String(company.companySecondaryColor) : ''
    this.companySecondaryDarkColor = company.companySecondaryColor ? String(darkenColor(company.companySecondaryColor, 20)) : ''
    this.companyCreatedAt = company.companyCreatedAt ? new Date(company.companyCreatedAt) : new Date()
  }
}

export class LeadWithContact {
  leadId
  contactId
  leadStageId
  leadStageName
  companyId
  companyName
  leadAffiliateId
  leadType
  leadAmount
  leadIRSBalance
  leadSource
  leadCreatedAt
  leadModifiedAt
  taxStatusId
  chartTaxpayerId
  chartAccessToken
  chartStatus
  chartStatusDescription
  chartInstantAccessToken
  contactName
  contactFirstName
  contactLastName
  contactEmail
  contactPhone
  contactLast4SSN
  contactBirthYear
  chartInstantTimestamp
  filingDate

  constructor(leadWithContact = {}) {
    this.leadId = leadWithContact.leadId ? String(leadWithContact.leadId) : ''
    this.contactId = leadWithContact.contactId ? String(leadWithContact.contactId) : ''
    this.leadStageId = leadWithContact.leadStageId ? String(leadWithContact.leadStageId) : ''
    this.leadStageName = leadWithContact.leadStageName ? String(leadWithContact.leadStageName) : ''
    this.companyId = leadWithContact.companyId ? String(leadWithContact.companyId) : ''
    this.companyName = leadWithContact.companyName ? String(leadWithContact.companyName) : ''
    this.leadAffiliateId = leadWithContact.leadAffiliateId ? String(leadWithContact.leadAffiliateId) : ''
    this.leadType = leadWithContact.leadType ? String(leadWithContact.leadType) : ''
    this.leadAmount = leadWithContact.leadAmount ? Number(leadWithContact.leadAmount) : 0
    this.leadIRSBalance = leadWithContact.leadIRSBalance ? Number(leadWithContact.leadIRSBalance) : 0
    this.leadSource = leadWithContact.leadSource ? String(leadWithContact.leadSource) : ''
    this.leadCreatedAt = leadWithContact.leadCreatedAt ? new Date(leadWithContact.leadCreatedAt) : new Date()
    this.leadModifiedAt = leadWithContact.leadModifiedAt ? new Date(leadWithContact.leadModifiedAt) : new Date()
    this.taxStatusId = leadWithContact.taxStatusId ? String(leadWithContact.taxStatusId) : ''
    this.chartTaxpayerId = leadWithContact.chartTaxpayerId ? String(leadWithContact.chartTaxpayerId) : ''
    this.chartAccessToken = leadWithContact.chartAccessToken ? String(leadWithContact.chartAccessToken) : ''
    this.chartStatus = leadWithContact.chartStatus ? String(leadWithContact.chartStatus) : ''
    this.chartStatusDescription = leadWithContact.chartStatusDescription ? String(leadWithContact.chartStatusDescription) : ''
    this.chartInstantAccessToken = leadWithContact.chartInstantAccessToken ? String(leadWithContact.chartInstantAccessToken) : ''
    this.contactName = leadWithContact.contactName ? String(leadWithContact.contactName) : ''
    this.contactFirstName = leadWithContact.contactFirstName ? String(leadWithContact.contactFirstName) : ''
    this.contactLastName = leadWithContact.contactLastName ? String(leadWithContact.contactLastName) : ''
    this.contactEmail = leadWithContact.contactEmail ? String(leadWithContact.contactEmail) : ''
    this.contactPhone = leadWithContact.contactPhone ? String(leadWithContact.contactPhone) : ''
    this.contactLast4SSN = leadWithContact.contactLast4SSN ? String(leadWithContact.contactLast4SSN) : ''
    this.contactBirthYear = leadWithContact.contactBirthYear ? String(leadWithContact.contactBirthYear) : ''
    this.chartInstantTimestamp = leadWithContact.chartInstantTimestamp ? String(leadWithContact.chartInstantTimestamp) : ''
    this.filingDate = leadWithContact.filingDate ? String(leadWithContact.filingDate) : ''
  }
}

export class Payment {
  paymentId
  affiliateId
  paymentAmount
  paymentDate
  linkURL

  constructor(payment = {}) {
    this.paymentId = payment.paymentId ? String(payment.paymentId) : ''
    this.affiliateId = payment.affiliateId ? String(payment.affiliateId) : ''
    this.paymentAmount = payment.paymentAmount ? Number(payment.paymentAmount) : 0
    this.paymentDate = payment.paymentDate ? String(payment.paymentDate) : ''
    this.linkURL = payment.linkURL ? String(payment.linkURL) : ''
  }
}

export const affiliateData = new AffiliateData()
export const company = new Company()
export let _selectedCompanyId = ''

export function _setSelectedCompanyId(companyId) {
  _selectedCompanyId = companyId
}